import { ScanQRWithHowto } from '@components/SwitchToMobile/steps/ScanQRWithHowto'
import { SwitchToMobileFlow } from './SwitchToMobileFlow'

export const SwitchToMobileWithHowtoPage = () => (
  <SwitchToMobileFlow ScanQRComponent={ScanQRWithHowto} />
)
